import {
  getBundle,
  getHistory,
  getPrices,
  getSectorMap
} from './market-gateway.js';

export async function fetchPricesLite() {
  const payload = await getPrices();
  return Array.isArray(payload?.rows) ? payload.rows : [];
}

export async function fetchSectorMapLite() {
  const payload = await getSectorMap();
  return Array.isArray(payload?.entries) ? payload.entries : [];
}

export async function fetchHistoryLite(symbol, limit = 20) {
  const payload = await getHistory(symbol, limit);
  return {
    symbol: String(payload?.symbol || '').toUpperCase(),
    rows: Array.isArray(payload?.rows) ? payload.rows : []
  };
}

export async function fetchHistoryBundleLite(symbols = [], limit = 365) {
  const uniqueSymbols = Array.from(new Set(
    (Array.isArray(symbols) ? symbols : [])
      .map((symbol) => String(symbol || '').trim().toUpperCase())
      .filter(Boolean)
  ));

  if (!uniqueSymbols.length) return {};

  const normalizedLimit = Math.max(2, Math.min(5000, Number.parseInt(limit, 10) || 365));
  const output = {};

  try {
    const bundle = await getBundle({
      historyLimit: normalizedLimit,
      symbolsForHistory: uniqueSymbols
    });

    const rawBySymbol = bundle?.historyBySymbol && typeof bundle.historyBySymbol === 'object'
      ? bundle.historyBySymbol
      : {};

    uniqueSymbols.forEach((symbol) => {
      const payload = rawBySymbol[symbol] || rawBySymbol[symbol.toUpperCase()] || null;
      output[symbol] = {
        symbol,
        rows: Array.isArray(payload?.rows) ? payload.rows : []
      };
    });
  } catch (_error) {
    uniqueSymbols.forEach((symbol) => {
      output[symbol] = { symbol, rows: [] };
    });
  }

  const missingSymbols = uniqueSymbols.filter((symbol) => !Array.isArray(output[symbol]?.rows) || !output[symbol].rows.length);
  if (!missingSymbols.length) return output;

  const settled = await Promise.allSettled(
    missingSymbols.map(async (symbol) => [symbol, await fetchHistoryLite(symbol, normalizedLimit)])
  );

  settled.forEach((result) => {
    if (result.status !== 'fulfilled') return;
    const [symbol, payload] = result.value;
    output[symbol] = {
      symbol,
      rows: Array.isArray(payload?.rows) ? payload.rows : []
    };
  });

  return output;
}
